import React, { useEffect, useState, useRef, useCallback } from "react";

import usePaginator from "~/hooks/usePaginator";
import Loader      from "~/components/loader";

const BasePaginator = ({ endpoint, card, classItem="", options={}, qs={}, hideEmpty = false})=> {

  const [items      , setItems]      = useState([]);
  const [pageNumber , setPageNumber] = useState(1);

  const {pagerLoading, pagerData, pagerHasMore} = usePaginator(endpoint, { page: pageNumber, ...qs });

  const observer     = useRef();
  const endOfListRef = useCallback((node)=> {
    if (pagerLoading || !node) {
      if(observer.current) observer.current.disconnect();
      return;
    };

    observer.current = new IntersectionObserver((entries) => {
      if (entries.shift().isIntersecting && pagerHasMore) {
        setPageNumber(prevPageNumber => prevPageNumber + 1);
      }
    });

    observer.current.observe(node);
  }, [pagerHasMore]);

  useEffect(()=> {
    if(!pagerData.length) return;
    setItems(prev=> Object.keys(qs).length ? [...pagerData] : [...prev, ...pagerData]);
  }, [pagerData]);

  useEffect(()=> setPageNumber(1), Object.values(qs));

  return (
    <div className="paginator">
      { items.map((item, index)=>
        <div key={index} className={classItem || ''} ref={items.length == index+1 ? endOfListRef : null }>
          { React.createElement(card,  {item, ...options} ) }
        </div>
      )}

      { !hideEmpty && !items.length && !pagerLoading && <h5 className='text-muted text-center'> Nothing here </h5> }
      { pagerLoading && !hideEmpty && <Loader type={19} center /> }
    </div>
  );
}

export default BasePaginator;
